import {Action, AnyAction, Reducer} from 'redux';

import {ReducerPredicate, StateId} from '../types';

export function createFilteredReducer<S = any, A extends Action = AnyAction>(
  reducerFunction: Reducer<S, A>,
  reducerPredicate: ReducerPredicate<A>
): Reducer<S, A> {
  return (state, action) => {
    const isInitializationCall = state === undefined;
    const shouldRunWrappedReducer =
      reducerPredicate(action) || isInitializationCall;
    return shouldRunWrappedReducer ? reducerFunction(state, action) : state;
  };
}

export function getInstanceReducerId(
  reducerId: string,
  instanceId?: string
): string {
  return reducerId + (instanceId ? `_${instanceId}` : '');
}

export function prepareWithStateIdFactory<T>() {
  return (stateId: StateId, payload: T) => {
    return {payload, meta: {stateId}};
  };
}

export default {
  createFilteredReducer,
  getInstanceReducerId,
  prepareWithStateIdFactory,
};
